"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _icons = require("../../media/icon/icons");
var _Icon = require("../../media/icon/Icon");
var _ = require("../..");
var _index = require("../../index");
var _icon = require("../../media/icon/icon.tokens");
var _jsxRuntime = require("react/jsx-runtime");
var StepCardWrapper = _styledComponents.default.div.withConfig({
  displayName: "stepCard__StepCardWrapper",
  componentId: "sc-cfqdi2-0"
})(["display:flex;flex-direction:column;width:", ";background-color:", ";"], function (_ref) {
  var width = _ref.width;
  return width;
}, _tokens.default.sky.sys.color.background.neutral[1]);
var HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "stepCard__HeaderWrapper",
  componentId: "sc-cfqdi2-1"
})(["", ";display:flex;justify-content:center;align-items:center;gap:", ";padding:", " ", ";border-top-right-radius:", ";border-top-left-radius:", ";border-style:solid;border-width:", ";border-color:", ";background-color:", ";"], function (_ref2) {
  var textLength = _ref2.textLength;
  return textLength < 20 ? _tokens.default.sky.sys.font.body['1'] : _tokens.default.sky.sys.font.body['2'];
}, _tokens.default.sky.sys.spacing[200], _tokens.default.sky.sys.spacing[200], _tokens.default.sky.sys.spacing[300], _tokens.default.sky.sys.size.borderradius[3], _tokens.default.sky.sys.size.borderradius[3], _tokens.default.sky.sys.size.borderwidth.thin, function (_ref3) {
  var completed = _ref3.completed;
  return completed ? _tokens.default.sky.sys.color.border.success : _tokens.default.sky.sys.color.border.enabled;
}, function (_ref4) {
  var completed = _ref4.completed;
  return completed ? _tokens.default.sky.comp.toast.color.background.success : _tokens.default.sky.sys.color.background.neutral[1];
});
var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "stepCard__ContentWrapper",
  componentId: "sc-cfqdi2-2"
})(["display:flex;flex-direction:column;padding:", ";gap:", ";border-style:solid;border-width:", ";border-color:", ";border-top:none;border-bottom-right-radius:", ";border-bottom-left-radius:", ";flex-grow:1;"], _tokens.default.sky.sys.spacing[300], _tokens.default.sky.sys.spacing[300], _tokens.default.sky.sys.size.borderwidth.thin, function (_ref5) {
  var completed = _ref5.completed;
  return completed ? _tokens.default.sky.sys.color.border.success : _tokens.default.sky.sys.color.border.enabled;
}, _tokens.default.sky.sys.size.borderradius[3], _tokens.default.sky.sys.size.borderradius[3]);
var BodyWrapper = _styledComponents.default.div.withConfig({
  displayName: "stepCard__BodyWrapper",
  componentId: "sc-cfqdi2-3"
})(["display:flex;flex-direction:column;gap:", ";flex-grow:1;"], _tokens.default.sky.sys.spacing[100]);
var Title = _styledComponents.default.div.withConfig({
  displayName: "stepCard__Title",
  componentId: "sc-cfqdi2-4"
})(["", " color:", ";"], _tokens.default.sky.sys.font.subheading['1'], function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? _tokens.default.sky.sys.color.text.disabled.onlight : _tokens.default.sky.sys.color.text.content.main;
});
var ChildrenWrapper = _styledComponents.default.div.withConfig({
  displayName: "stepCard__ChildrenWrapper",
  componentId: "sc-cfqdi2-5"
})(["", ";display:flex;flex-direction:column;color:", ";"], _tokens.default.sky.sys.font.body['1'], function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? _tokens.default.sky.sys.color.text.disabled.onlight : _tokens.default.sky.sys.color.text.content.main;
});
var Svg = _styledComponents.default.svg.withConfig({
  displayName: "stepCard__Svg",
  componentId: "sc-cfqdi2-6"
})(["pointer-events:none;height:56px;width:56px;", ""], function (_ref8) {
  var color = _ref8.color;
  return (0, _styledComponents.css)(["path{fill:", ";}"], _icon.tokens.color[color]);
});
var StepCard = function StepCard(_ref9) {
  var _ref9$completed = _ref9.completed,
    completed = _ref9$completed === void 0 ? false : _ref9$completed,
    _ref9$disabled = _ref9.disabled,
    disabled = _ref9$disabled === void 0 ? false : _ref9$disabled,
    headerTitle = _ref9.headerTitle,
    headerIcon = _ref9.headerIcon,
    _ref9$title = _ref9.title,
    title = _ref9$title === void 0 ? 'Title' : _ref9$title,
    _ref9$width = _ref9.width,
    width = _ref9$width === void 0 ? '100%' : _ref9$width,
    icon = _ref9.icon,
    children = _ref9.children,
    _ref9$button = _ref9.button,
    label = _ref9$button.label,
    _ref9$button$emphasis = _ref9$button.emphasis,
    emphasis = _ref9$button$emphasis === void 0 ? _index.EMPHASIS.MEDIUM : _ref9$button$emphasis,
    onClick = _ref9$button.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StepCardWrapper, {
    width: width,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(HeaderWrapper, {
      completed: completed,
      textLength: headerTitle.length,
      children: [headerIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        className: 'header-icon',
        icon: headerIcon,
        size: 'l',
        color: completed ? "success" : "default"
      }), headerTitle]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ContentWrapper, {
      completed: completed,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(BodyWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Svg, {
          color: disabled ? "disabled" : "default",
          viewBox: '0 0 24 24',
          xmlns: "http://www.w3.org/2000/svg",
          children: _icons.icons[icon]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Title, {
          disabled: disabled,
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ChildrenWrapper, {
          disabled: disabled,
          children: children
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Button, {
        noMargin: true,
        fullWidth: true,
        disabled: disabled,
        emphasis: disabled ? _index.EMPHASIS.HIGH : emphasis,
        onClick: onClick,
        children: label
      })]
    })]
  });
};
var _default = exports.default = StepCard;